var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.41,
    height: 13.604,
    viewBox: "0 0 9.41 13.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "green-arrow",
    transform: "translate(0.233 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M92.536,60.015l3.45-3.859c.164-.186.328-.366.491-.551h-.77l3.45,3.859c.164.186.328.366.491.551.469.524,1.239-.251.77-.77l-3.45-3.859c-.164-.186-.328-.366-.491-.551a.544.544,0,0,0-.77,0l-3.45,3.859c-.164.186-.328.366-.491.551-.469.519.3,1.294.77.77Z",
    transform: "translate(-91.62 -54.675)",
    fill: "#44dec5",
    stroke: "#44dec5",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(3.924 0.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M163.5,59.1V71.331c0,.5,1.092.5,1.092,0V59.1c0-.5-1.092-.5-1.092,0Z",
    transform: "translate(-163.5 -58.725)",
    fill: "#44dec5",
    stroke: "#44dec5",
    strokeWidth: 0.4
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.cb3704754331f53fefba0378a24ddbc2.svg";
export { ForwardRef as ReactComponent };